import {
  dataLayer,
  CombinedClevertapProps,
} from "@repo/analytics/data-layer-utils";
import { dlEventConstants } from "@repo/analytics/data-layer.constants";

/**
 * Logs Data Layer and optional CleverTap event for Market Securities interaction.
 *
 * @param ctaText - The CTA button text (e.g., tab name)
 * @param tabPosition - Index of the tab or section
 * @param cleverTapObj - Optional additional data for CleverTap tracking
 */
export const handleMarketSecuritiesDL = (
  loginStatus: string,
  ctaText: string,
  tabPosition: number,
  cleverTapObj?: CombinedClevertapProps,
) => {
  const data = {
    event: dlEventConstants.CLICK,
    event_type: dlEventConstants.BUTTON_CLICK,
    cta_text: ctaText,
    tab_position: tabPosition.toString(),
  };

  dataLayer(loginStatus, data, cleverTapObj);
};
